'use strict';


const angular = require('angular');

module.exports = angular
  .module('spinnaker.widget.clusterSelector.directive', [])
  .directive('clusterSelector', function() {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        model: '=',
        clusters: '=',
        required: '=?',
        toggled: '&?',
        onChange: '&?'
      },
      controllerAs: 'vm',
      controller: function controller() {
        var vm = this;

        vm.toggled = vm.toggled || angular.noop;
        vm.onChange = vm.onChange || angular.noop;
        vm.required = vm.required || false;

        let selectedNotInClusterList = () => {
          return !(angular.isArray(vm.clusters) && vm.clusters.length && vm.clusters.some((cluster) => cluster === vm.model));
        };

        let modelIsSet = () => {
          return vm.model !== undefined || vm.model !== null || vm.model.trim() !== '';
        };

        vm.clusterChanged = function() {
          vm.onChange({clusterName:vm.model});
        };

        vm.freeFormClusterField = modelIsSet() ? selectedNotInClusterList() : false;

        vm.toggleFreeFormClusterField = function(event) {
          event.preventDefault();
          vm.freeFormClusterField = !vm.freeFormClusterField;
          vm.toggled({isToggled: vm.freeFormClusterField});
        };

      },
      templateUrl: require('./scopeClusterSelector.directive.html')
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/widgets/scopeClusterSelector.directive.js